import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCrossMedium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"cross-medium, crossed medium, close"} maskId="square-filled-radius-0-stroke-1-IconCrossMedium"><path d="M18.707 6L12.707 12L18.707 18L18 18.707L12 12.707L6 18.707L5.29297 18L11.293 12L5.29297 6L6 5.29297L12 11.293L18 5.29297L18.707 6Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconCrossMedium;
